import script from "./IbanFields.vue?vue&type=script&setup=true&lang=ts"
export * from "./IbanFields.vue?vue&type=script&setup=true&lang=ts"

import "./IbanFields.vue?vue&type=style&index=0&id=1c99514b&lang=scss"

const __exports__ = script;

export default __exports__